<template>
	<el-form-item label="显示类型">
		<el-select v-model="data.options.type" style="width: 100%" @change="handleRange">
			<el-option label="year" value="year" />
			<el-option label="month" value="month" />
			<el-option label="date" value="date" />
			<el-option label="dates" value="dates" />
			<el-option label="datetime" value="datetime" />
			<el-option label="week" value="week" />
			<el-option label="datetimerange" value="datetimerange" />
			<el-option label="daterange" value="daterange" />
			<el-option label="monthrange" value="monthrange" />
		</el-select>
	</el-form-item>

	<template v-if="data.options.type === 'datetimerange' || data.options.type === 'daterange' || data.options.type === 'monthrange'">
		<el-form-item label="开始时间占位内容">
			<el-input v-model="data.options.startPlaceholder" />
		</el-form-item>
		<el-form-item label="结束时间占位内容">
			<el-input v-model="data.options.endPlaceholder" />
		</el-form-item>
	</template>
	<template v-else>
		<el-form-item label="占位内容">
			<el-input v-model="data.options.placeholder" />
		</el-form-item>
	</template>

	<el-form-item label="格式">
		<el-input v-model="data.options.format" />
	</el-form-item>

	<el-form-item label="默认值">
		<el-date-picker
			v-model="data.options.defaultValue"
			style="width: 100%"
			:format="data.options.format"
			:type="data.options.type"
			:placeholder="data.options.placeholder"
			:start-placeholder="data.options.startPlaceholder"
			:end-placeholder="data.options.endPlaceholder"
			clearable
		/>
	</el-form-item>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'

export default defineComponent({
	name: 'ItemDate',
	props: {
		active: {
			type: Object,
			default: null
		}
	},
	emits: ['update:active'],
	setup(props, context) {
		const data = ref(props.active)
		watch(data, val => context.emit('update:active', val), { deep: true })

		const handleRange = () => {
			data.value.options.defaultValue = ''
			data.value.options.placeholder = ''
			data.value.options.startPlaceholder = ''
			data.value.options.endPlaceholder = ''
		}

		return {
			data,
			handleRange
		}
	}
})
</script>
